callpy_global.CLogger = function()
{
    this.module_name = "Logger ";
    this.module_log_rang = 100;

    this.errorLevels = {
        "ALL": 0,
        "ALLEXCEPTINFO": 1,
        "ERRORSWARNINGS": 2,
        "ERRORSONLY": 3,
        "NONE": 4
    };

    var _this = this;

    this.log = function ()
    {
        if (_this.errorLevels[callpy_global.errorLevel]<2) console.log.apply(console, arguments);
    }
    this.error = function ()
    {
        if (_this.errorLevels[callpy_global.errorLevel]<4) console.error.apply(console, arguments);
    }
    this.info = function ()
    {
        if (_this.errorLevels[callpy_global.errorLevel]<1) console.info.apply(console, arguments);
    }
    this.warn = function ()
    {
        if (_this.errorLevels[callpy_global.errorLevel]<3) console.warn.apply(console, arguments);
    }
    this.groupCollapsed = function ()
    {
        if (console.groupCollapsed && _this.errorLevels[callpy_global.errorLevel]<2) console.groupCollapsed.apply(console, arguments);
    }
    this.groupEnd = function ()
    {
        if (console.groupEnd && _this.errorLevels[callpy_global.errorLevel]<2) console.groupEnd.apply(console, arguments);
    }
};
